import React, { useState, useEffect } from "react";
import { TextField, TextareaAutosize } from "@mui/material";
import { StyledFeedbackCell } from "../../pages/AdminAssignmentPage/components/DetailAssignments";

const EditableInputCell = ({ id, value, onChange, name }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [localValue, setLocalValue] = useState(value || "");

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <StyledFeedbackCell onClick={() => setIsEditing(true)}>
      {isEditing ? (
        <TextareaAutosize
          size="large"
          value={localValue}
          onChange={(e) => setLocalValue(e.target.value)}
          onBlur={() => {
            onChange(name, localValue, id);
            setIsEditing(false);
          }}
          autoFocus
          style={{
            width: "100%",
            fontSize: "16px",
            minHeight: "60px",
            padding: "8px",
          }}
        />
      ) : (
        <div
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {value}
        </div>
      )}
    </StyledFeedbackCell>
  );
};

export default EditableInputCell;
